import template from './cuotas.html';
import abrirTemplate from '../../cajas/list/abrir.html';
import { FormActions } from 'core/services/form';
import cuotasI18N from 'i18n/cuotas/es.json';
import config from 'config.json';
import { rest } from 'core/api';
import { download } from '../../../core/util';
import { formatErrorMessage } from 'core/util';


export let CuotasComponent = {
  templateUrl: template,
  selector: 'cuotas',
  bindings: {
    translations: '='
  },
  controller: CuotasCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(cuotasI18N).concat(commonsI18N);

CuotasCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService', 'ConfirmationModal', 'CustomModal', 'localStorageService', '$resource', 'HeadersUtil'
];

function CuotasCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService, ConfirmationModal, CustomModal, localStorageService, $resource, HeadersUtil) {

  var defaultColumnOrder = ['factura.numeroComprobante', 'factura.cliente.razonSocial', 'cantidadCuotas', 'cantidadCuotasPagadas', 'fechaProximoVencimiento', 'factura.total', 'entregaInicial', 'saldo', 'estado.value'];
  BasicFactory.setup('cuotas');

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_cuota_cabecera');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));
  this.localModel = {};
  this.$state = $state;

  this.options = {
    resource: 'cuotas',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de cuotas'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'factura.numeroComprobante', title: this.translations['Número Comprobante'] },
      { data: 'factura.cliente.razonSocial', title: this.translations['Cliente'] },
      { data: 'cantidadCuotas', title: this.translations['Cantidad Total Cuotas'] },
      { data: 'cantidadCuotasPagadas', title: this.translations['Cantidad Cuotas Pagadas'] },
      { 
        data: 'fechaProximoVencimiento', 
        title: this.translations['Fecha Proximo Vencimiento'], 
        type: 'date-range',
        render: function(data, type, row) {
          return data ? data : '<i>No establecido</i>';
        } 
      },
      { data: 'factura.total', title: this.translations['Total'], renderWith: 'monedaRender' },
      { data: 'entregaInicial', title: this.translations['Entrega Inicial'], renderWith: 'monedaRender' },
      { data: 'saldo', title: this.translations['Saldo'], renderWith: 'monedaRender' },
      {
        data: 'estado.value',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onView: onView.bind(this),
    canCobrar: canCobrar.bind(this),
    canRemoveCondition: () => false,
    canEditCondition: canEditCondition.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Cobrar'] + '" ng-show="options.canCobrar(rowsData[<%= dataId %>])" ng-click="cobrarCuota(<%= dataId %>)"> <span class="glyph-icon icon-money" style="top: -8px;"></span></button>',
        functionName: 'cobrarCuota',
        functionDef: (itemId) => {
          let self = this;
          CustomModal.open({
            title: 'Cobrar Cuota',
            id: itemId,
            message: '¿Desea cobrar cuotas?',
            ok: function() {
              let caja = localStorageService.get('caja');
              if (!caja) {
                ngNotify.set(self.translations['Debe asignar una caja al equipo'], 'warn');
                return;
              } else if (!caja.sesionActual || caja.sesionActual.estado.value !== 'Abierta') {
                self.abrirCaja('cobrar', itemId);
              } else {
                self.gotoFormCobrar(itemId);
              }
            }
          });
        }
      }
    ]
  };

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.abrirCaja = abrirCaja.bind(this);
  this.gotoFormCobrar = gotoFormCobrar.bind(this);
  
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de cuotas']
    };
    this.form();
  };

  function mapStateToThis(state) {
    if (state.currentUser) {
      this.user = state.currentUser.data;
    }

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

  }

  function onEdit(itemId) {
    $state.go('home.cuotas.uid.edit', { uid: itemId });
  }

  function onView(itemId) {
    $state.go('home.cuotas.uid.view', { uid: itemId });
  }

  function canEditCondition(data) {
    return false;
  }

  function canCobrar(data) {
    return (data.estado.value === 'Saldo Pendiente') && AuthorizationService.hasPermission('create_pago_cuotas');
  }

  function abrirCaja(operacion, itemId) {
    let caja = localStorageService.get('caja');

    let self = this;
    this.localModel.payload = {};
    CustomModal.open({
      title: 'Abrir Caja',
      caja: caja,
      templateUrl: abrirTemplate,
      usuario: this.user,
      fecha: moment(new Date()).format('DD/MM/YYYY hh:mm'),
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.abrirCaja({ id: caja.id }, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data.sesionActual.estado.value === 'Abierta') {
            ngNotify.set(self.translations['Abierta Correctamente'], 'success');
            localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
            if (operacion === 'cobrar') {
              self.gotoFormCobrar(itemId);
            }
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  function gotoFormCobrar(itemId) {
    $state.go('home.cuotas.uid.cobrar', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/cuotas/list/cuotas.component.js